import React, { useState } from 'react';
import PageBanner from '@/components/site/PageBanner';
import SEO from '@/components/site/SEO';
import { User, Lock } from 'lucide-react';

const Login = () => {
  const [form, setForm] = useState({ user: '', pass: '' });
  const [msg, setMsg] = useState('');
  const submit = (e) => {
    e.preventDefault();
    localStorage.setItem('finirio_session', JSON.stringify({ user: form.user, ts: Date.now() }));
    setMsg('Login successful (demo).');
  };
  return (
    <main>
      <SEO
        title="Login | Finirio Customer Portal"
        description="Sign in to your Finirio account to track your loan application, view offers and manage your profile."
        path="/login"
      />
      <PageBanner title="Login" crumbs={[ 'Login' ]} />
      <section className="py-16 bg-white">
        <div className="max-w-[440px] mx-auto px-4">
          <div className="border border-slate-100 rounded-lg p-8 bg-slate-50">
            <h2 className="text-[22px] font-semibold text-slate-800 mb-6 text-center">Sign in to your account</h2>
            <form className="space-y-4" onSubmit={submit}>
              <div className="flex items-center border border-slate-300 rounded overflow-hidden focus-within:ring-2 focus-within:ring-[#1e73be]/30">
                <span className="px-3 h-11 grid place-items-center bg-white border-r border-slate-200 text-slate-500"><User className="w-4 h-4" /></span>
                <input required placeholder="Username or Email" value={form.user} onChange={(e) => setForm({ ...form, user: e.target.value })} className="flex-1 h-11 px-3 outline-none" />
              </div>
              <div className="flex items-center border border-slate-300 rounded overflow-hidden focus-within:ring-2 focus-within:ring-[#1e73be]/30">
                <span className="px-3 h-11 grid place-items-center bg-white border-r border-slate-200 text-slate-500"><Lock className="w-4 h-4" /></span>
                <input required placeholder="Password" type="password" value={form.pass} onChange={(e) => setForm({ ...form, pass: e.target.value })} className="flex-1 h-11 px-3 outline-none" />
              </div>
              <button type="submit" className="w-full h-11 rounded text-white font-medium hover:brightness-110 transition" style={{ backgroundColor: '#1e73be' }}>Login</button>
              {msg && <p className="text-center text-sm text-emerald-700">{msg}</p>}
              <div className="text-center text-sm text-slate-500 pt-2">
                Forgot password? <a href="#" className="text-[#1e73be] hover:underline">Reset</a>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Login;
